import type { FC } from 'react';

import { Progress } from 'src/app/components/Elements';
import type { ButtonProps } from 'src/app/components/Elements/Button';
import Button from 'src/app/components/Elements/Button';

export interface SubmitButtonProps extends Pick<ButtonProps, 'className' | 'style' | 'size'> {
  block?: boolean;
  disabled?: boolean;
  isSubmitting: boolean;
  onClick?: () => void;
}

/**
 * @deprecated Use design system SubmitButton
 */
const SubmitButton: FC<SubmitButtonProps> = ({ isSubmitting, disabled, onClick, children, ...rest }) => {
  return (
    <Button
      {...rest}
      onClick={isSubmitting || disabled ? undefined : onClick}
      aria-disabled={isSubmitting || disabled}
      disabled={isSubmitting || disabled}
      type="submit"
    >
      {isSubmitting && (
        <Progress
          size={16}
          thickness={2.5}
          color="inherit"
          style={{ marginRight: '0.5rem', verticalAlign: '-0.2rem' }}
        />
      )}
      {children}
    </Button>
  );
};

export default SubmitButton;
